import { useState, useEffect } from "react";
import { API, AUTH } from "../adminUtils";
import "../admin-base.css";
import "../admin-layout.css";
import "../admin-controls.css";
import "../admin-responsive.css";
import "./settingsTab.css";

export default function SettingsTab() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [saved, setSaved]       = useState(false);
  const [newEmail, setNewEmail] = useState("");

  useEffect(() => {
    fetch(`${API}/settings`, { headers: AUTH })
      .then(r => r.json())
      .then(d => setSettings(d.settings))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async (patch) => {
    setSaving(true); setSaved(false);
    try {
      const res = await fetch(`${API}/settings`, {
        method: "PATCH",
        headers: { ...AUTH, "Content-Type": "application/json" },
        body: JSON.stringify(patch),
      });
      const d = await res.json();
      setSettings(d.settings);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch {}
    finally { setSaving(false); }
  };

  const addEmail = () => {
    const trimmed = newEmail.trim();
    if (!trimmed || settings.adminEmails.includes(trimmed)) return;
    const updated = [...settings.adminEmails, trimmed];
    setSettings(s => ({ ...s, adminEmails: updated }));
    save({ adminEmails: updated });
    setNewEmail("");
  };

  const removeEmail = email => {
    const updated = settings.adminEmails.filter(e => e !== email);
    setSettings(s => ({ ...s, adminEmails: updated }));
    save({ adminEmails: updated });
  };

  if (loading) return <div className="adm-tab-content"><p className="adm-loading">Loading…</p></div>;

  const notifOn = settings?.notificationMode !== "off";

  return (
    <div className="adm-tab-content">
      <h2 style={{ fontSize: "1.1rem", fontWeight: 700, marginBottom: "1.5rem", color: "var(--color-grey-600)" }}>Settings</h2>

      <div className="adm-settings-section">
        <h3 className="adm-settings-heading">Notifications</h3>

        <div className="adm-settings-row">
          <label className="adm-settings-label">Admin notifications</label>
          <div className="adm-radio-group">
            <label className="adm-radio-label">
              <input
                type="radio"
                name="notifMode"
                value="on"
                checked={notifOn}
                onChange={() => save({ notificationMode: "digest" })}
              />
              On — 8pm evening digest + 30 min pre-class reminder
            </label>
            <label className="adm-radio-label">
              <input
                type="radio"
                name="notifMode"
                value="off"
                checked={!notifOn}
                onChange={() => save({ notificationMode: "off" })}
              />
              Off
            </label>
          </div>
        </div>

        <div className="adm-settings-row">
          <label className="adm-settings-label">Notification recipients</label>
          <div className="adm-email-list">
            {settings?.adminEmails?.map(e => (
              <div key={e} className="adm-email-chip">
                <span>{e}</span>
                <button className="adm-email-remove" onClick={() => removeEmail(e)}>✕</button>
              </div>
            ))}
            <div className="adm-email-add-row">
              <input
                className="adm-input"
                placeholder="Add email address"
                value={newEmail}
                onChange={e => setNewEmail(e.target.value)}
                onKeyDown={e => e.key === "Enter" && addEmail()}
              />
              <button className="adm-btn-primary" onClick={addEmail} disabled={saving}>
                {saving ? "Saving…" : "Add"}
              </button>
            </div>
          </div>
          {saved && <p className="adm-saved">✓ Saved</p>}
        </div>
      </div>
    </div>
  );
}